import { AgGridReact } from "ag-grid-react";
import { useState,useCallback } from "react";

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import "./style.scss"

const AgGridApp=()=>{
    const [rowData,setRowData] = useState([
    ]);

    const [targetText,setTargetText]=useState("")
    
    const [columnDefs,setColumnDef] = useState([])
    const columnDefsMedalsIncluded = [
        { field: 'athlete',editable:false},
        { field: 'gold' },
        { field: 'silver' },
        { field: 'bronze',editable:true},
        { field: 'total' },
        { field: 'age' },
        { field: 'country' },
        { field: 'sport' },
        { field: 'year' },
        { field: 'date' },
      ];

    const defaultColDef={
        editable:true,
    }

    const onGridReady = useCallback((params) => {
        fetch('https://www.ag-grid.com/example-assets/olympic-winners.json')
          .then((resp) => resp.json())
          .then((data) => setRowData(data));
          // 列ヘッダの定義が当初と変わっているので再定義
          setColumnDef(columnDefsMedalsIncluded)
      }
      , []);
    
    const onClickRowDataOutput=()=>{
        console.log(rowData)
    }
    
    const onCellValueChanged=(event)=>{
        console.log(rowData)
        setTargetText(String(rowData[0]['gold']))
    }
    return(
        <>
        This is AgGridApp
        <div className="ag-theme-alpine" style={{height: 400, width: 600}}>
           <AgGridReact
                defaultColDef={defaultColDef}
               rowData={rowData}
               columnDefs={columnDefs}
               onGridReady={onGridReady}
               onCellValueChanged={(event)=>{onCellValueChanged(event)}}
               >
           </AgGridReact>
       </div>
       

       <button onClick={()=>{onClickRowDataOutput()}}>
        表のデータをコンソールに表示
       </button>
       <div>
        １行目のgold<br></br>
        {targetText}
        </div>
        </>
    )
}

export default AgGridApp;